function bindFilters() {
    var $trigger = $(".filters .trigger"),
        $filters = $(".filters li"),
        $filter = $(".filters"),
        $reset = $(".filters li.reset");

    $trigger.unbind();

    $trigger.click(function() {
        $(this).siblings("ul").toggleClass("visible");
    });

    $filters.click(function () {
        var $input = $(this).find("input");
        $input.trigger("click");
        $(this).find("span").toggleClass("active", $input.is(":checked"));
        updateFilterStatus();
    });

    $reset.click(function() {
        $(this).parents("ul").find("span.active").click();
    });

    function updateFilterStatus() {
        $filter.each(function () {
            var hasActive = $(this).find("span.active").length > 0;
            $(this).find(".trigger .icon").toggleClass("active", hasActive);
        });
    }

    updateFilterStatus();
};

$(document).ready(function () {
    bindFilters();
    bindNewFilters();
});

function bindNewFilters() {
    //var $toggles = $(".new-filter-toggle");
    var $filter = $(".new-filters");
    $(document).off('click', '.new-filter-toggle').on('click', '.new-filter-toggle', function () {
        var $targetName = $(this).data("filter-toggles");
        var $target = $filter.find("input[name='" + $targetName + "']");
        var check = $(this).data("filter-checked");

        if (check == undefined || check === 1 && !$target.is(":checked") || check === 0 && $target.is(":checked")) {
            $target.trigger("click");
            var isChecked = $target.is(":checked");
            $(".new-filter-toggle[data-filter-toggles='" + $targetName + "']").each(function(index, element) {
                var $el = $(element);
                var targetValue = $el.data("filter-checked");

                if (targetValue === undefined) {
                    $el.toggleClass("active", isChecked);
                }
                else  {
                    $el.toggleClass("active", (targetValue === 1 && isChecked || targetValue !== 1 && !isChecked));
                }
            });
        }
    });
}